import { useRouteMatch } from 'react-router';
import { get } from 'lodash';
import { MODULE_TEMPLATE } from 'config/routes';
import { useMultiLayerDrawerEnabled } from '../modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { matchPathWithoutQuery } from '../modules/taboola-common-frontend-modules/query-params';
import { useDrawerStack } from './queryParams/useDrawerStack';

export const useModuleName = () => {
    const routeMatch = useRouteMatch(MODULE_TEMPLATE);
    const isRenderReportConstantlyEnabled = useMultiLayerDrawerEnabled();
    const { stack } = useDrawerStack();

    if (!stack.length || !isRenderReportConstantlyEnabled) {
        return get(routeMatch, 'params.module');
    }

    const match = matchPathWithoutQuery(stack[0].path, { path: MODULE_TEMPLATE });

    if (!match) {
        return get(routeMatch, 'params.module');
    }

    return get(match, 'params.module');
};
